<template>
  <div class="login">
    <div class="t1">

    </div>
    <div class="t2">
      <div class="inp1">
        <span> {{ $lang(42618)}} </span>
        <el-input class="inp2" v-model="put.mail" :placeholder="$lang(42625)"></el-input>
      </div>
      <div class="inp1">
        <span> {{ $lang(42619)}} </span>
        <el-input class="inp2" :placeholder="$lang(42626)" v-model="put.pwd" show-password></el-input>
      </div>
      <div class="inp1">
        <span> {{ $lang(50026)}} </span>
        <el-input class="inp2" :placeholder="$lang(42626)" v-model="put.rpwd" show-password></el-input>
      </div>

      <div class="btn">
        <el-button class="btn1" type="primary" @click="sbmt">{{ $lang(50119)}} </el-button>
      </div>

      <div class="remark txtmid">
        <span style="color:red">*</span>
        <span><el-checkbox v-model="checked"> </el-checkbox> {{ $lang(70068)}} </span>
        <span style="color: rgb(250 116 21);" @click="show_page(6)">《{{ $lang(70069)}}》 </span>
        <span style="color: rgb(250 116 21);" @click="show_page(5)"> 《{{ $lang(70070)}}》 </span>
      </div>
      <div class="remark2">
        <span style="color:rgb(250 116 21);" @click="jump('/login', {}, true)">{{ $lang(50115)}} </span>
        &nbsp;
        <span style="color:rgb(250 116 21);" @click="jump('/', {}, true)">{{ $lang(50120)}} </span>

      </div>
    </div>

    <div class="t3">
      <i class="el-icon-close" @click="back()"></i>
    </div>

    <page_tc ref="pag_tc"></page_tc>

  </div>
</template>

<script>
import page_tc from '../../components/page_tc.vue';
export default {
  components: { page_tc },
    name:"login",
    data() {
        return {
          put : {
            mail: '',
            pwd: '',
            rpwd: '',
            openid : '',
          },
          checked: true,

        }
    },
    methods:{
      show_page(id) {
        // alert(id)

        this.$refs.pag_tc.f5(id)
      },
      sbmt() {
        if (!this.checked) {
          this.$message({
            type: 'error',
            message: ` ${this.$lang(70071)}《${this.$lang(70069)}》《${this.$lang(70070)}》   `
          });
          return
        }

        var emailReg = /^\w{3,}(\.\w+)*@[A-z0-9]+(\.[A-z]{2,5}){1,2}$/;

        if (!emailReg.test(this.put.mail)) {
          this.$message({
            type: 'success',
            message: this.$lang(50124)
          });
          return
        }

        if (this.put.pwd.length < 6) {
          this.$message({

            message: this.$lang(50015)
          });
          return;
        }
        if (this.put.pwd != this.put.rpwd) {
          this.$message({

            message: this.$lang(50016)
          });
          return;
        }

        if (this.cache('openid')) {
          this.put.openid = this.cache('openid')
        }

        this.get("/pub/reg", this.put, 'post').then((e) => {
          this.cache('openid', '');
          this.cache('info', e.info);
          this.cache('token', e.token);
          this.$message({
            type: 'success',
            message: this.$lang(50122)
          });
          let url = localStorage.getItem('pcwxbkurl')


          if (url) {
            window.location.href = url
          } else {
            this.jump('/bus_list', {}, true)
          }


        });
      }
    }
}
</script>

<style scoped>
.login{
    width: 1100px;
    height: 100vh;
      background-image: url("~@/../static/image/login.png");
      background-repeat: no-repeat;
    margin: 0 auto;
    z-index: 4;
    display: flex;
}
.login .t1{
    flex: 0 0 50%;
}
.login .t2{
    margin: 0 auto;
    margin-top: 4%;
    display: flex;
    flex-direction: column;
}
.login .inp1{
    margin-bottom: 10%;
    display: flex;
    flex-direction: column;
}
.login .inp1 span{
    margin-left: 5%;
    margin-bottom: 3%;
    color: rgb(33, 37, 41);
    font-family: Noto Sans SC;
    font-size: 14px;
    font-weight: 500;
    line-height: 21px;
    letter-spacing: 0%;
}
.login .inp1 .inp2{
    width: 280px;
    height: 5vh;
    background: rgb(249, 250, 254);
    border-radius: 8px;
}
.login .btn1{
    width: 280px;
    height: 5vh;
    background: rgb(4, 100, 221);
    border-radius: 8px;

}
.login .remark{
    display: flex;
    margin-top: 5%;
}
.login .remark span{
    font-family: Noto Sans SC;
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    letter-spacing: 0%;
    text-align: left;
}
.login .remark2{
    display: flex;
    margin: 0 auto;
    margin-top: 15%;
}
.login .remark2 span{
    font-family: Noto Sans SC;
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    letter-spacing: 0%;

}
.login .t3 {
    margin-top: 3%;
    margin-right: 4%;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/reg.vue